import { inject } from '@angular/core';
import {
  CanActivateFn,
  Router,
} from '@angular/router';
import { environment } from '../../environments/environment';
import { IdentityService } from '../services/identity';

/** Unauthenticated protected navigation starts the environment's configured login. */
export const requireAuthentication: CanActivateFn = async (_route, state) => {
  const identity = inject(IdentityService);
  const router = inject(Router);
  try {
    if (await identity.hasValidSession()) {
      return true;
    }
    await identity.signIn(environment.autoLoginProvider, state.url);
    return false;
  } catch {
    return router.createUrlTree(['/sign-in'], {
      queryParams: { authFailed: '1', returnUrl: state.url },
    });
  }
};
